import { BaseProvider } from './core/providers/base'
import { GoogleAnalyticsProvider } from './core/providers/google-analytics'
// import { Config } from '../ConfigManager'

class AnalyticsInitializer {
  private static instance: AnalyticsInitializer
  private providers: BaseProvider[] = []

  private constructor() {}

  public static getInstance(): AnalyticsInitializer {
    if (!AnalyticsInitializer.instance) {
      AnalyticsInitializer.instance = new AnalyticsInitializer()
    }
    return AnalyticsInitializer.instance
  }

  public init(): void {
    const gaProvider = new GoogleAnalyticsProvider({
      // measurementId: Config.googleAnalyticsId,
      measurementId: import.meta.env.VITE_GA_ID,
      method: import.meta.env.VITE_GA_METHOD,
      type: 'google-analytics',
    })
    gaProvider.initialize()
    this.providers = [gaProvider]
  }

  public getProviders(): BaseProvider[] {
    return this.providers
  }
}

export const analyticsInit = AnalyticsInitializer.getInstance()
